import { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    // Create bouncing text elements
    const phrases = [
      "NEVER GONNA GIVE YOU UP!",
      "YOU'VE BEEN RICKROLLED!",
      "😎 GOTCHA! 😎",
      "NO ESCAPE!",
      "DANCE TIME! 🕺",
    ];
    
    phrases.forEach((phrase) => {
      const text = document.createElement('div');
      text.className = 'bouncing-text';
      text.textContent = phrase;
      text.style.left = Math.random() * (window.innerWidth - 200) + 'px';
      text.style.top = Math.random() * (window.innerHeight - 50) + 'px';
      text.style.animationDelay = Math.random() * 2 + 's';
      document.body.appendChild(text);
    });

    // Cleanup function
    return () => {
      const bouncingTexts = document.querySelectorAll('.bouncing-text');
      bouncingTexts.forEach(text => text.remove());
    };
  }, []);

  const handleUnmute = () => {
    setIsMuted(false);
  };

  return (
    <div className="video-container">
      {/* Hey, you found the flag! */}
      <div style={{ display: 'none' }}>
        {/* CreekCTF{R1ckr0llllll3d} */}
        <span id="flag">{"CreekCTF{R1ckr0llllll3d}"}</span>
      </div>
      <iframe
        className="video-frame"
        src={`https://www.youtube.com/embed/1P5yyeeYF9o?autoplay=1&mute=${isMuted ? 1 : 0}&loop=1&playlist=1P5yyeeYF9o`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      {isMuted && (
        <div 
          className="fixed inset-0 flex items-center justify-center z-[1001]"
          onClick={handleUnmute}
        >
          <div className="bg-white/80 px-6 py-3 rounded-full text-black font-bold text-xl animate-pulse cursor-pointer hover:bg-white/90">
            CLICK HERE FOR MAC AND CHEESE!!!
          </div>
        </div>
      )}
    </div>
  );
}

export default App; 